import MuiTableRow from '@mui/material/TableRow';

export const TableHeadRow = MuiTableRow;
